import PropTypes from 'prop-types';
import React from 'react';

/**
 * Create a clip path for cropping a ellipse.
 *
 * @param {{}} props
 * @param {string} props.cropId
 * @param {{}} props.cropOptions
 * @returns {{}}
 */
export function CropEllipse({cropId, cropOptions}) {
  const halfWidth = (cropOptions.width / 2);
  const halfHeight = (cropOptions.height / 2);

  const offsetX = cropOptions.left + halfWidth;
  const offsetY = cropOptions.top + halfHeight;
  const radiusX = cropOptions.radiusX || halfWidth;
  const radiusY = cropOptions.radiusY || halfHeight;

  return (
    <clipPath id={cropId}>
      <ellipse cx={offsetX} cy={offsetY} rx={radiusX} ry={radiusY} />
    </clipPath>
  );
}

CropEllipse.propTypes = {
  cropId: PropTypes.string.isRequired,
  cropOptions: PropTypes.shape({
    height: PropTypes.number.isRequired,
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,

    radiusX: PropTypes.number,
    radiusY: PropTypes.number,
  }).isRequired,
};

export default CropEllipse;
